import React, { useEffect, useState } from "react";
import rsfservice from "../../../../services/rsfservice";
import { Badge, Table } from "react-bootstrap";
import MoneyBadge from "../common/MoneyBadge";

const AllReconRequests = () => {
  const [reconData, setReconData] = useState(null);
  const [loading, setLoading] = useState(false);

  const FetchReconRequests = async () => {
    setLoading(true);
    const response = await rsfservice.getReconRequests();
    console.log(response.data);
    setReconData(response);
    setLoading(false);
  };

  useEffect(() => {
    FetchReconRequests();
  }, []);

  if (loading) {
    return <h1>Loading...</h1>;
  }

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          {/* <th>ID</th> */}
          <th>Amount</th>
          {/* <th>Collector ID</th>
          <th>Collector URI</th> */}
          <th>Commission</th>
          {/* <th>Message ID</th> */}
          <th>Order ID</th>
          <th>Order Value</th>
          <th>Payment ID</th>
          <th>Receiver ID</th>
          <th>Receiver URI</th>
          <th>Recon Status</th>
          <th>Settlement ID</th>
          <th>Status</th>
          <th>TCS</th>
          <th>TDS</th>
          <th>Transaction ID</th>
          <th>Withholding Amount</th>
        </tr>
      </thead>
      <tbody>
        {reconData?.data.map((item, index) => (
          <tr key={index}>
            {/* <td>{item._id}</td> */}
            <td>
              {item.amount.currency} <MoneyBadge price={item.amount.value} />
            </td>
            {/* <td>{item.collector_id}</td>
            <td>{item.collector_uri}</td> */}
            <td>
              {item.commision.currency}{" "}
              <MoneyBadge price={item.commision.value} />
            </td>
            {/* <td>{item.message_id}</td> */}
            <td>{item.order_id}</td>
            <td>{item.order_value}</td>
            <td>{item.payment_id}</td>
            <td>{item.receiver_id}</td>
            <td>{item.receiver_uri}</td>
            <td><Badge>{item.recon_status}</Badge></td>
            <td>{item.settlement_id}</td>
            <td>{item.status}</td>
            <td>
              {item.tcs.currency} <MoneyBadge price={item.tcs.value} />
            </td>
            <td>
              {item.tds.currency} <MoneyBadge price={item.tds.value} />
            </td>
            <td>{item.transaction_id}</td>
            <td>
              {item.withholding_amount.currency}{" "}
              <MoneyBadge price={item.withholding_amount.value} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AllReconRequests;
